import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import { DataObj } from "./HeaderObj";
// import CounterDetails from "../CounterDetails/counterDetails";

// Import banner images
import Garudab from "../../image/diwali banner.png";
import headbanner from "../../image/garudahead.jpg";
// import headbanner2 from "../../image/garudahead2.jpg";

const Header = () => {        
  const images = [Garudab,headbanner];
  const [current, setCurrent] = useState(0);

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 10000); // slide every 3 sec
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="bg-gray">
      {/* Blogs & Updates */}
      <div className="absolute top-[200px] z-10 left-[-55px] bg-white news rounded-b">
        <Link className="hidden sm:block pl-2 pr-2 capitalize" to="/blogs">
          Blogs & updates
        </Link>
      </div>

      {/* Banner + Counter + Cards */}
      <div className="w-full relative flex flex-col items-center justify-center mb-5 sm:mb-10 ">
        {/* Banner Section */}
        <div className="w-full relative overflow-hidden">
          {/* Slide Wrapper */}
          <div
            className="flex transition-transform duration-1000 ease-in-out"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {images.map((img, index) => (
              <img
                key={index}
                className="md:h-[450px] w-full flex-shrink-0"
                src={img}
                alt={`banner-${index}`}
              />
            ))}
          </div>

          {/* Navigation dots */}
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-4 h-2 rounded-full ${
                  current === index ? "bg-white" : "bg-yellow"
                }`}
              ></button>
            ))}
          </div>
        </div>

        {/* Counter Section */}
        <div className="w-full mt-1">
          {/* <CounterDetails /> */}
        </div>

        {/* Card Section (DataObj) */}
        <div className="relative grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 px-4 py-3">
  {DataObj &&
    DataObj.map((item) => {
      return (
        <NavLink
          key={item.id}
          to={item.route}
          className="group relative w-full h-[150px] sm:h-[200px] md:h-[220px] 
                     flex flex-col items-center justify-start p-4
                     bg-/80 backdrop-blur-md 
                     border-2 border-orange-800 shadow-md rounded-2xl 
                     transition-all duration-500 ease-out 
                     hover:scale-105 hover:shadow-2xl hover:border-[#9F2725]/40"
        >
          {/* Floating Image */}
          <div className="absolute -top-7 flex items-center justify-center w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-[#9F2600] shadow-md group-hover:scale-110 transition-transform duration-500">
            <img
              className="w-16 h-16 sm:w-14 sm:h-14 rounded-full object-cover"
              src={item.image}
              alt="logo"
            />
          </div>

          {/* Content */}
          <div className="flex flex-col items-center text-center mt-8 sm:mt-12 space-y-1 px-2">
            <h1 className="font-semibold text-[12px] sm:text-base md:text-lg text-[#9F2725] group-hover:text-[#8a0209] transition-colors">
              {item.heading}
            </h1>
            <p className="font-medium text-[9px] sm:text-xs md:text-sm text-gray-600 leading-tight line-clamp-3">
              {item.details}
            </p>

            {/* Button */}
            <button className="relative flex items-center font-medium text-[9px] sm:text-xs md:text-sm text-[#9F2725]">
              <span className="relative after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[1.5px] sm:after:h-[2px] after:bg-[#9F2725] after:transition-all after:duration-500 group-hover:after:w-full">
                Know More
              </span>
              <span className="ml-2 text-[#9F2725] group-hover:translate-x-1 transition-transform duration-500">
                <FaRegArrowAltCircleRight />
              </span>
            </button>
          </div>
        </NavLink>
      );
    })}
</div>

      </div>
    </div>
  );
};

export default Header;
